// extracted by mini-css-extract-plugin
export default {"pageWrapper":"ScanCellPage_pageWrapper__rWD-n","title":"ScanCellPage_title__e86+6","cellWrapper":"ScanCellPage_cellWrapper__6V0a7"};